import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader } from '@/http-common';

const state = () => ({
    statusesOrkList: {}, // Информация об юзере
});

const getters = {
    GET_COLOR_STATUS: (state) => (id) => {
        const statusesColor = {
            1: {
                cls: 'status_redacted',
            },
            2: {
                cls: 'status_waiting',
            },
            3: {
                cls: 'status_success',
            },
            4: {
                cls: 'status_danger',
            },
            5: {
                cls: 'status_redacted',
            },
        }

        return statusesColor[id];
    },
};

const mutations = {
    // Изменение информации о юзере
    SET_ORK_STATUSES(state, statusesOrkList) {
        state.statusesOrkList = statusesOrkList
    }
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    // Получить информацию о пользователе
    async LOAD_ORK_STATUSES({ commit, rootState }) {
        await httpWithLoader.get(`/ork/statuses`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ORK_STATUSES', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    async CHANGE_ORK_STATUS({ rootState }, { orkId, statusId }) {
        await httpWithLoader.post(`/user/ork/${ orkId }/status/${ statusId }`, null, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then()
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
